import { useAuth } from "../Context/AuthContext";
import React from "react";
import { Navigate } from "react-router-dom";

const RequireAdmin = ({ children }) => {
  const { user } = useAuth();

  if (!user || user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
};
export default RequireAdmin;
